import dynamic from "next/dynamic";
import { NextSeo } from "next-seo";
import Layout from "@/components/layout/blog";

const Top = dynamic(() => import("@/components/about-us/top"), {
  suspense: true,
});

const Vacancy = dynamic(() => import("@/components/careers/vacancy"), {
  suspense: true,
});

export default function Index() {
  return (
    <Layout>
      <NextSeo
        title="Open Positions - Job Openings at IS Auditr"
        canonical="https://isauditr.com/careers"
        keywords="Careers, IS Auditr Careers, Job Openings, Content writier Job Openings, social media executive Job Openings, Iso Consultant Job Openings"
        description="Ready to join the exciting team at IS Auditr? Check out current job openings in fields like content writing, social media, and Iso Consultancy – apply now!"
        twitter={{
          cardType: "summary_large_image",
          site: "@isauditr",
          handle: "@isauditr",
          creator: "@isauditr",
        }}
        openGraph={{
          type: `article`,
          locale: `en_US`,
          siteName: "IS Auditr",
          title: "Open Positions - Job Openings at IS Auditr",
          description:
            "Ready to join the exciting team at IS Auditr? Check out current job openings in fields like content writing, social media, and Iso Consultancy – apply now!",
          url: `https://isauditr.com/careers`,
          publisherName: "IS Auditr",
          publisherLogo: "https://isauditr.com/images/logo.svg",
        }}
      />

      <div
        data-elementor-type="wp-page"
        data-elementor-id="77"
        className="elementor elementor-77"
      >
        <Top
          title="Jobs at IS Auditr"
          subTitle1="Make your next career move with amazing open postion. Although we are a young company, we believe it is important to provide good benefits and job satisfaction. We are looking for curious, creative people who are open to taking small steps and big leaps and ready to ask lots and find as many answers as possible."
          subTitle2="We’ve got growing teams in Mohali and Kangra and though the distance may separate some of us, that doesn’t stop us from collaborating. Join our team and you’ll get the thrill and intellectual stimulation of an startup without the pretense and pretension."
        />

        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-62ac14c elementor-section-full_width elementor-section-height-default elementor-section-height-default"
          data-id="62ac14c"
          data-element_type="section"
        >
          <div className="elementor-container elementor-column-gap-no">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4734801"
              data-id="4734801"
              data-element_type="column"
            >
              <div
                className="elementor-widget-wrap elementor-element-populated"
                style={{
                  padding: "2%",
                  margin: "5%",
                  borderStyle: "solid",
                  borderWidth: "2px 0 0",
                  borderColor: "#E23125",
                  transition:
                    "background .3s,border .3s,border-radius .3s,box-shadow .3s",
                }}
              >
                <Vacancy
                  title="ISO Consultant"
                  type="Full Time"
                  slug="iso-consultant"
                  location="Mohali, Punjab"
                  exceprt=" We are looking for a ISO Consultant with expertise in ISO 9001, SOC2, and ISO 27001 to join our team."
                />

                <Vacancy
                  title="Content Writer"
                  type="Full Time"
                  slug="content-writer"
                  location="Mohali, Punjab"
                  exceprt="We are looking for a Content Writer to join our editorial team and enrich our websites with new blog posts, guides and marketing copy."
                />

                <Vacancy
                  title="Social Media Executive"
                  type="Full Time"
                  slug="social-media-executive"
                  location="Mohali, Punjab"
                  exceprt="We are looking for a social media executive to oversee our company's presence on a multitude of public platforms."
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
}
